<template>
  <b-row>
    <!-- Confirm Modal -->
    <section>
      <b-modal id="confirmItem" v-model="showConfirmItemForm" :centered="true" size="lg" title="Confirm Form">
        <b-form-group label="Order Number" v-if="confirmItem">
          <b-form-input name="form-input-orderNumber" v-model="confirmItem.orderNumber" />
        </b-form-group>

        <b-form-group label="From Warehouse" v-if="confirmItem">
          <b-v-select name="form-input-warehouseId" v-model="confirmItem.warehouseId" :searchable="true" :options="warehousesList" />
        </b-form-group>

        <template v-slot:modal-footer>
          <b-button type="reset" variant="outline-secondary" @click="showConfirmItemForm = false">
            Cancel
          </b-button>

          <b-button type="button" variant="primary" @click="MarkAsConfirmed()">
            Confirm
          </b-button>
        </template>
      </b-modal>
    </section>

    <section class="w-100" v-if="itemLoaded">
      <!-- Header -->
      <div class="header">
        <div class="header-body">
          <div class="row align-items-end">
            <div class="col">
              <h1 class="header-title">
                Bulk Order
              </h1>
            </div>
            <div class="col-auto">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="small" v-if="is('brand-user')">Brand</span>
                  <span class="small" v-else>Client</span>
                  <h5>
                    <span v-if="myBrands && myBrands.find(a => a.id == itemForm.brandId)">
                      {{ myBrands.find(a => a.id == itemForm.brandId).name }}
                    </span>
                    <span v-else>-</span>
                  </h5>
                </div>
                <div class="col-auto">
                  <span class="small">From Warehouse</span>
                  <h5>
                    <span v-if="myWarehouses && myWarehouses.find(a => a.id == itemForm.warehouseId)">
                      {{ myWarehouses.find(a => a.id == itemForm.warehouseId).name }}
                    </span>
                    <span v-else>-</span>
                  </h5>
                </div>
                <div class="col-auto">
                  <span class="small">Order number</span>
                  <h5>{{ itemForm.orderNumber }}</h5>
                </div>
                <div class="col-auto" v-if="itemForm.customReferenceNumber">
                  <span class="small">Customer Ref #</span>
                  <h5>{{ itemForm.customReferenceNumber }}</h5>
                </div>
                <div class="col-auto">
                  <span class="small">Order status</span>
                  <h5>
                    <span :class="statusBadgeClass">{{ statusDisplayText }}</span>
                  </h5>
                </div>
                <div class="col-auto" v-if="itemForm.expectedDateTimeUtc">
                  <span class="small">Expected At</span>
                  <h5>{{ itemForm.expectedDateTimeUtc | moment('add', '0 hours', 'MMM Do YYYY') }}</h5>
                </div>
                <div class="col-auto">
                  <span class="small">Shipped At</span>
                  <h5 v-if="itemForm.shipDateTimeUtc">
                    <span v-if="itemForm.shipDateTimeUtc && !itemForm.shipDateTimeUtc.endsWith('Z')">
                      {{ (itemForm.shipDateTimeUtc + 'Z') | moment('MMM Do, h:mm a') }}
                    </span>
                    <span v-else-if="itemForm.shipDateTimeUtc">
                      {{ itemForm.shipDateTimeUtc | moment('MMM Do, h:mm a') }}
                    </span>
                  </h5>
                  <h5 v-else>-</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row px-3">
        <div class="col-12 col-sm-9">
          <!-- Ship To Address Card -->
          <b-card class="mb-3" no-body>
            <template v-slot:header>
              <div class="card-header-small pt-1">Ship To Address</div>
            </template>
            <div class="card-body">
              <div class="form-row">
                <div class="col-6">
                  <b-form-group label="Ship To Name">
                    <b-form-input :value="itemForm.shipmentAddress.name" :disabled="true" />
                  </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                  <b-form-group label="Country">
                    <b-form-input :value="itemForm.shipmentAddress.countryCode" :disabled="true" />
                  </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                  <b-form-group label="Address Line 1">
                    <b-form-input :value="itemForm.shipmentAddress.addressLine1" :disabled="true" />
                  </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                  <b-form-group label="City">
                    <b-form-input :value="itemForm.shipmentAddress.city" :disabled="true" />
                  </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                  <b-form-group label="Address Line 2">
                    <b-form-input :value="itemForm.shipmentAddress.addressLine2" :disabled="true" />
                  </b-form-group>
                </div>
                <div class="col-6 col-md-3">
                  <b-form-group label="State">
                    <b-form-input :value="itemForm.shipmentAddress.state" :disabled="true" />
                  </b-form-group>
                </div>
                <div class="col-6 col-md-3">
                  <b-form-group label="Postcode">
                    <b-form-input :value="itemForm.shipmentAddress.postcode" :disabled="true" />
                  </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                  <b-form-group label="Address Line 3">
                    <b-form-input :value="itemForm.shipmentAddress.addressLine3" :disabled="true" />
                  </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                  <b-form-group label="Contact Email">
                    <b-form-input :value="itemForm.shipmentAddress.email" :disabled="true" />
                  </b-form-group>
                </div>
              </div>
            </div>
          </b-card>

          <!-- Items Card -->
          <b-card class="mb-3" header="Items To Ship" no-body>
            <div class="card-body">
              <div class="items">
                <b-table
                  head-variant="light"
                  :fields="shipItemsFields"
                  :items="itemForm.items"
                  :bordered="true"
                >
                  <template v-slot:cell(quantity)="data">
                    <section class="d-flex">
                      <div>{{ data.item.quantity }}</div>
                      <div class="ml-auto">
                        <div v-if="data.item.fulfillmentInfo">
                          <b-popover
                            container="body"
                            boundary="viewport"
                            v-if="data.item.fulfillmentInfo"
                            class="popovermappings"
                            :target="'fulfilmnt' + data.item.id"
                            triggers="hover"
                            placement="top"
                          >
                            <template v-slot:title>Fulfillment Info</template>
                            <section>
                              <div class="border-bottom pb-1 pt-1" v-for="fulfillInfoItem in data.item.fulfillmentInfo" :key="fulfillInfoItem.id">
                                <div class="d-flex">
                                  <div>Qty: {{ fulfillInfoItem.quantity }}</div>
                                  <div>
                                    <div>
                                      <span v-if="fulfillInfoItem.lpn" class="badge badge-secondary ml-1">From Pallet ID: {{ fulfillInfoItem.lpn }}</span>
                                    </div>
                                    <div>
                                      <span v-if="fulfillInfoItem.lotNumber" class="badge badge-info ml-1">Lot #: {{ fulfillInfoItem.lotNumber }}</span>
                                    </div>
                                    <div>
                                      <span v-if="fulfillInfoItem.expirationDate" class="badge badge-danger ml-1">Expires: {{ fulfillInfoItem.expirationDate | moment('MMMM Do YYYY') }}</span>
                                    </div>
                                    <div>
                                      <span v-if="fulfillInfoItem.serialNumbers && fulfillInfoItem.serialNumbers.length" class="badge badge-warning ml-1">
                                        Serial Numbers:
                                        <span v-for="(fulfillInfoItemSerialNum, key) in fulfillInfoItem.serialNumbers" :key="key">{{ fulfillInfoItemSerialNum }},</span>
                                      </span>
                                    </div>
                                    <div>
                                      <span v-if="fulfillInfoItem.tplReceiveItemId" class="badge badge-warning ml-1">Ref ID: {{ fulfillInfoItem.tplReceiveItemId }}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </section>
                          </b-popover>
                          <span :id="'fulfilmnt' + data.item.id" class="d-inline-block badge badge-primary mr-1">
                            <i class="fa fa-info-circle"></i> Details
                          </span>
                        </div>
                      </div>
                    </section>
                  </template>
                  <template v-slot:cell(sku)="data">
                    <CopyText :text="data.item.warehouseProductItem" />
                  </template>
                  <template v-slot:cell(name)="data">
                    <span>{{ GetItemName(data.item.warehouseProductItem) }}</span>
                  </template>
                </b-table>
              </div>
            </div>
          </b-card>

          <!-- Package Units List -->
          <PackageUnitsList v-if="itemForm.packageUnits && itemForm.packageUnits.length > 0" :packages="itemForm.packageUnits" :items="wareItemsList" class="mb-3" />

        </div>

        <!-- Sidebar -->
        <aside class="col-12 col-sm-3">
          <b-card header="Actions">
            <b-button
              :to="{ name: 'Warehouses.BulkShipments.Edit', params: { id: itemForm.id } }"
              v-if="isEditable"
              class="btn btn-block btn-warning"
            >
              Edit Shipment
            </b-button>
            <b-button
              @click="ConfirmItemForm(itemForm)"
              v-if="itemForm.orderStatus == 'Draft' && has('pm.warehouses.bulkShipments.confirm')"
              class="btn btn-block btn-success"
            >
              Approve Order
            </b-button>
            <b-button
              @click="CancelOrder(itemForm)"
              v-if="itemForm.orderStatus != 'Shipped' && itemForm.orderStatus != 'Cancelled'"
              class="btn btn-block btn-danger"
            >
              Cancel Order
            </b-button>
            <b-button
              block
              variant="info"
              v-if="has('pm.customerBilling.billingEntries')"
              @click="showClientBillingLedger = true"
            >
              Client Billing Ledger
            </b-button>
            <ClientBillingLedgerSidebar
              v-model="showClientBillingLedger"
              :related-id="itemForm.id"
              related-type="BulkShipment"
            />
            <router-link
              class="mt-2 btn btn-block btn-outline-secondary"
              :to="{ name: 'Warehouses.BulkShipments.Index' }"
              exact
            >
              Back To List
            </router-link>

            <b-form-group label="Connect Log" class="mt-2" v-if="!is('brand-user') && itemForm.connectLog">
              <b-form-textarea
                :value="itemForm.connectLog"
                :disabled="true"
                rows="7"
                max-rows="12"
              />
            </b-form-group>
          </b-card>

          <!-- Fulfillment Card -->
          <b-card header="Fulfilment Info" class="mt-3" v-if="!is('brand-user') && has('pm.warehouses.bulkShipments.confirm')">
            <b-button
              :to="{ name: 'Warehouses.BulkShipments.AllocateShipment', params: { bulkShipmentId: itemForm.id } }"
              v-if="itemForm.orderStatus == 'Open' && has('pm.warehouses.bulkShipments.confirm')"
              class="btn btn-block btn-primary"
            >
              Allocate and Ship Order
            </b-button>
            <b-button
              v-b-tooltip.hover
              v-if="itemForm.packageUnits && itemForm.packageUnits.length > 0 || (itemForm.allocationRequest && has('pm.warehouses.bulkShipments.confirm'))"
              title="Download Packing List"
              variant="info"
              block
              @click="DownloadPackingListPdfItem(itemForm)"
            >
              <i class="fa fa-file-pdf-o mr-1"></i> Download Packing List
            </b-button>
            <b-button
              variant="outline-primary"
              block
              @click="showPackagesOverlay = true"
            >
              <i class="fa fa-archive mr-1"></i> Edit Pallets/Packages
            </b-button>
            <b-button
              v-if="itemForm.orderStatus == 'Open'"
              variant="success"
              block
              :disabled="!itemForm.fullyAllocated"
              @click="showMarkShippedSidebar = true"
            >
              <i class="fa fa-check mr-1"></i> Mark as Shipped
            </b-button>
            <b-button
              v-if="itemForm.packageUnits && itemForm.packageUnits.length > 0"
              variant="outline-info"
              block
              @click="DownloadPackingLabels(itemForm)"
            >
              <i class="fa fa-tag mr-1"></i> Download Packing Labels
            </b-button>
            <b-button
              variant="outline-info"
              v-if="(!itemForm.packageUnits || itemForm.packageUnits.length === 0)"
              block
              :disabled="!itemForm.fullyAllocated"
              @click="AutoGenPackagesAndDownloadLabels(itemForm)"
            >
              <i class="fa fa-magic mr-1"></i> Autogen. Packages &amp; Get Labels
            </b-button>
          </b-card>

          <!-- Shipment Info Card (for shipped orders) -->
          <div class="card" v-if="itemForm.orderStatus == 'Shipped'">
            <div class="card-header c-pointer" v-b-toggle.shipmentInfo-options-collapse>
              <h4 class="card-header-title">Shipment Info</h4>
              <i class="fa fa-chevron-down"></i>
            </div>
            <div>
              <b-collapse visible id="shipmentInfo-options-collapse">
                <div class="card-body">
                  <div class="row">
                    <b-form-group label="Carrier" class="col-6">
                      <b-form-input :value="itemForm.carrierShippedWith" :disabled="true" />
                    </b-form-group>
                    <b-form-group label="Service" class="col-6">
                      <b-form-input :value="itemForm.carrierServiceShippedWith" :disabled="true" />
                    </b-form-group>
                  </div>
                  <b-form-group label="Tracking Number">
                    <b-form-input :value="itemForm.carrierTrackingNumber" :disabled="true" />
                  </b-form-group>
                  <b-form-group label="Shipped At">
                    <b-form-input
                      v-if="itemForm.shipDateTimeUtc && !itemForm.shipDateTimeUtc.endsWith('Z')"
                      :value="(itemForm.shipDateTimeUtc + 'Z') | moment('MMM Do YY, h:mm a')"
                      :disabled="true"
                    />
                    <b-form-input
                      v-else
                      :value="itemForm.shipDateTimeUtc | moment('MMM Do YY, h:mm a')"
                      :disabled="true"
                    />
                  </b-form-group>
                </div>
              </b-collapse>
            </div>
          </div>

          <!-- Attachments Card -->
          <b-card header="Attachments" no-body>
            <div class="card-body">
              <div v-if="itemForm.attachments">
                <b-media class="border-bottom mb-1 pb-1" v-for="attachmnt in itemForm.attachments" :key="attachmnt.id">
                  <template #aside>
                    <div class="bg-grey rounded bg-rounded">
                      <template v-if="attachmnt.type == 'PDF'">
                        <i class="fa fa-file-pdf-o"></i>
                      </template>
                      <template v-else-if="attachmnt.type == 'Document'">
                        <i class="fa fa-file-word-o"></i>
                      </template>
                      <template v-else-if="attachmnt.type == 'Spreadsheet'">
                        <i class="fa fa-file-excel-o"></i>
                      </template>
                      <template v-else-if="attachmnt.type == 'Zip'">
                        <i class="fa fa-zip-o"></i>
                      </template>
                      <template v-else-if="attachmnt.type == 'Image'">
                        <i class="fa fa-file-picture-o"></i>
                      </template>
                      <template v-else>
                        <i class="fa fa-file-code-o"></i>
                      </template>
                    </div>
                  </template>
                  <b class="mt-0">
                    <a target="_blank" :href="attachmnt.url" download>{{ attachmnt.name }}</a>
                  </b>
                  <p class="mb-0">
                    <span class="small">Added on: {{ fullHumanDate(attachmnt.addedAtDateTimeUtc, 'MMMM Do YYYY, h:mm a') }}</span>
                  </p>
                </b-media>
              </div>
              <input
                id="fileImportManualShip"
                ref="fileImportManualShip"
                type="file"
                class="d-none"
                accept=".pdf,.zip,.xls,.xlsx,.docx,.doc,.txt,.png,.jpeg,.jpg,.gif,.webm"
                name="fileImportManualShip"
                @change="ImportFileHandler()"
              />
              <label for="fileImportManualShip" class="mt-2 btn btn-block btn-outline-primary">
                <span><i class="fa fa-file-o"></i> Attach a Document</span>
              </label>
            </div>
          </b-card>

          <!-- EDI Documents Card -->
          <b-card header="EDI Documents" v-if="has('pm.warehouses.bulkShipments.confirm')">
            <div v-if="loadingEdiDocuments" class="text-center">
              <b-spinner small></b-spinner> Loading EDI documents...
            </div>
            <div v-else-if="ediDocuments && ediDocuments.length > 0">
              <b-card v-for="doc in ediDocuments" :key="doc.id" class="mb-2" no-body>
                <div class="card-body p-2">
                  <div class="d-flex align-items-center">
                    <div class="mr-2">
                      <i
                        v-if="doc.processingFailed"
                        class="fa fa-times-circle text-danger"
                        v-b-tooltip.hover
                        :title="doc.errorMessage || 'Processing failed'"
                      ></i>
                      <i v-else class="fa fa-check-circle text-success"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div class="d-flex align-items-center">
                        <i
                          v-if="doc.wasCreatedByConnect"
                          class="fa fa-arrow-up text-success mr-1"
                          v-b-tooltip.hover
                          title="Outgoing (created by Connect)"
                        ></i>
                        <i
                          v-else
                          class="fa fa-arrow-down text-danger mr-1"
                          v-b-tooltip.hover
                          title="Incoming"
                        ></i>
                        <strong class="small">{{ doc.type }}</strong>
                      </div>
                      <div class="small text-muted">{{ doc.fileName }}</div>
                      <div v-if="doc.processedAtDateTime" class="small text-muted">
                        {{ doc.processedAtDateTime | moment('MMM Do, h:mm a') }}
                      </div>
                      <div v-else-if="doc.createDatetimeUtc" class="small text-muted">
                        {{ doc.createDatetimeUtc + 'Z' | moment('MMM Do, h:mm a') }}
                      </div>
                    </div>
                    <div v-if="doc.wasCreatedByConnect" class="ml-2">
                      <b-button
                        size="sm"
                        variant="outline-primary"
                        v-b-tooltip.hover
                        title="Resend to SPS"
                        @click="ResendEdiDocument(doc.id)"
                      >
                        <i class="fa fa-repeat"></i>
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
            <div v-else class="text-muted small">
              No EDI documents found for this shipment.
            </div>
          </b-card>

          <DiscussionsWidget v-bind="chatWidgetProps" v-if="chatWidgetProps.relatedId"></DiscussionsWidget>
        </aside>
      </div>
    </section>

    <!-- Loading state -->
    <div v-else class="w-100 text-center p-5">
      <b-spinner></b-spinner>
      <p class="mt-2">Loading shipment...</p>
    </div>

    <!-- Mark as Shipped Sidebar -->
    <b-sidebar
      v-model="showMarkShippedSidebar"
      right
      shadow
      backdrop
      bg-variant="white"
      title="Mark as Shipped"
      width="360px"
    >
      <div class="px-3 py-3">
        <b-form-group label="Tracking Number (optional)">
          <b-form-input v-model="markShippedForm.trackingNumber" placeholder="Enter tracking number" />
        </b-form-group>
        <b-button
          variant="success"
          block
          :disabled="markShippedLoading"
          @click="SubmitMarkShipped()"
        >
          <b-spinner small v-if="markShippedLoading" class="mr-1" />
          Mark as Shipped
        </b-button>
      </div>
    </b-sidebar>

    <!-- Packages Overlay -->
    <PackagesOverlay
      v-if="itemLoaded"
      v-model="showPackagesOverlay"
      :manual-shipment-id="itemForm.id"
      :default-unit-type="myBrands && myBrands.find(a => a.id == itemForm.brandId) ? myBrands.find(a => a.id == itemForm.brandId).autoPackageManualShipmentMode : null"
      :items="wareItemsList"
    />
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
import DiscussionsWidget from '@/views/components/DiscussionsWidget';
import PackagesOverlay from './PackagesOverlay.vue';
import PackageUnitsList from './PackageUnitsList.vue';
import ClientBillingLedgerSidebar from '../../../components/ClientBillingLedgerSidebar.vue';

export default {
  name: 'BulkShipments.View',
  mixins: [crudMixinGen('bulkShipments'), myCommonDataMixin],
  components: {
    DiscussionsWidget,
    PackagesOverlay,
    ClientBillingLedgerSidebar,
    PackageUnitsList
  },

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data: function() {
    return {
      showClientBillingLedger: false,
      itemLoaded: false,
      showConfirmItemForm: false,
      confirmItem: null,
      showPackagesOverlay: false,
      showMarkShippedSidebar: false,
      markShippedLoading: false,
      markShippedForm: {
        trackingNumber: ''
      },
      ediDocuments: [],
      loadingEdiDocuments: false,
      wareItemsList: [],

      chatWidgetProps: {
        startOpen: true,
        channelType: 'FeatureClientSupport',
        relatedDesc: 'Discussion for Bulk Shipment',
        relatedName: 'Bulk Shipment: ',
        relatedId: '',
        relatedType: 'BulkShipment'
      },

      shipItemsFields: [
        { key: 'sku', label: 'SKU', sortable: false },
        { key: 'name', label: 'Name', sortable: false },
        { key: 'quantity', label: 'Quantity', sortable: false }
      ]
    };
  },

  computed: {
    ...mapGetters({
      countryCodeList: 'getCountryCodeList',
      USAStateCodeList: 'getUSAStateCodeList'
    }),

    isEditable: function() {
      var editableStatuses = ['Draft', 'Open', 'OnHold'];
      return editableStatuses.indexOf(this.itemForm.orderStatus) !== -1;
    },

    statusBadgeClass: function() {
      var status = this.itemForm.orderStatus;
      if (status === 'Shipped') return 'badge badge-success';
      if (status === 'Draft') return 'badge badge-warning';
      if (status === 'Cancelled') return 'badge badge-danger';
      if (status === 'Open') return 'badge badge-primary';
      if (status === 'OnHold') return 'badge badge-secondary';
      if (status === 'AwaitingShipment') return 'badge badge-info';
      return 'badge badge-secondary';
    },

    statusDisplayText: function() {
      var status = this.itemForm.orderStatus;
      if (status === 'Draft') return 'Request (Pending)';
      if (status === 'OnHold') return 'On Hold';
      return status;
    }
  },

  watch: {
    id: function(val) {
      this.LoadItem(val);
    },
    '$route.params.id': function(val) {
      this.LoadItem(val);
    }
  },

  meta: function() {
    var titl = this.itemForm.orderNumber ? 'Bulk Shipment: ' + this.itemForm.orderNumber : 'Bulk Shipment';
    return {
      title: titl
    };
  },

  mounted: function() {
    this.ResetForm();
    this.LoadItem(this.id);
  },

  methods: {
    fullHumanDate: function(date, str) {
      return this.$moment.utc(date).local().format(str);
    },

    LoadItem: function(id) {
      var self = this;
      this.$http
        .get('/api/common/manualShipments/' + id)
        .then(function(resp) {
          var item = resp.data;
          self.itemForm = item;

          // Ensure shipmentAddress exists
          if (!self.itemForm.shipmentAddress) {
            self.itemForm.shipmentAddress = {
              name: '',
              addressLine1: '',
              addressLine2: '',
              addressLine3: '',
              city: '',
              state: '',
              postcode: '',
              countryCode: '',
              email: ''
            };
          }

          self.chatWidgetProps.relatedName = 'Bulk: ' + item.orderNumber;
          self.chatWidgetProps.relatedId = item.id;
          self.itemLoaded = true;

          self.LoadEdiDocuments(id);
          self.LoadWareProductsFor(item.brandId, item.warehouseId);
        })
        .catch(function(err) {
          console.error('Error loading shipment', err);
          self.$swal({ title: 'Failed to load shipment', icon: 'error' });
        });
    },

    LoadEdiDocuments: function(manualShipmentId) {
      var self = this;
      if (!this.has('pm.warehouses.bulkShipments.confirm')) {
        return;
      }
      this.loadingEdiDocuments = true;
      this.$http
        .get('/api/common/edi-documents/by-reference-id/' + manualShipmentId)
        .then(function(resp) {
          self.ediDocuments = resp.data || [];
          self.loadingEdiDocuments = false;
        })
        .catch(function(err) {
          console.error('Error loading EDI documents', err);
          self.ediDocuments = [];
          self.loadingEdiDocuments = false;
        });
    },

    LoadWareProductsFor: function(brandId, warehouseId) {
      var self = this;
      if (!brandId) return;

      var url = warehouseId
        ? '/api/common/purchaseOrders/pickItems/' + brandId + '/' + warehouseId
        : '/api/common/purchaseOrders/pickItems/' + brandId;

      this.$http
        .post(url)
        .then(function(resp) {
          self.wareItemsList = resp.data;
        })
        .catch(function(err) {
          self.wareItemsList = [];
        });
    },

    GetItemName: function(prodItem) {
      var nam = '-';
      var prodFound = this.wareItemsList.find(function(a) { return a.item === prodItem; });
      if (prodFound) {
        nam = prodFound.description;
      }
      return nam;
    },

    ConfirmItemForm: function(item) {
      this.confirmItem = item;
      this.showConfirmItemForm = true;
    },

    MarkAsConfirmed: function() {
      var self = this;
      if (!this.confirmItem || !this.confirmItem.id) {
        this.$swal({ title: 'Error', text: 'No Shipment Picked!', icon: 'error' });
        return;
      }
      if (!this.confirmItem.warehouseId) {
        this.$swal({ title: 'Error', text: 'No Warehouse was Picked!', icon: 'error' });
        return;
      }
      this.$swal({
        title: 'Are you sure you want to approve this bulk shipment?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, approve!'
      }).then(function(result) {
        if (result.value) {
          self.showConfirmItemForm = false;
          self.$http
            .post('/api/common/manualShipments/confirm/' + self.confirmItem.id + '/' + self.confirmItem.warehouseId + '/' + self.confirmItem.orderNumber)
            .then(function(resp) {
              if (resp.data.success) {
                self.confirmItem = null;
                self.$swal('Done!', 'The order was approved.', 'success');
                self.LoadItem(self.id);
              } else {
                self.$swal({ title: 'Error!', text: resp.data.errorMessage, icon: 'error' });
              }
            })
            .catch(function(err) {
              if (err.response && err.response.data && err.response.data.errorMessage) {
                self.$swal({ title: err.response.data.errorMessage, icon: 'error' });
              } else {
                self.$swal({ title: 'Something went wrong!', icon: 'error' });
              }
            });
        } else {
          self.showConfirmItemForm = false;
        }
      });
    },

    SubmitMarkShipped: function() {
      var self = this;
      this.markShippedLoading = true;
      this.$http
        .post('/api/common/manualShipments/' + this.itemForm.id + '/mark-shipped', {
          trackingNumber: this.markShippedForm.trackingNumber
        })
        .then(function(resp) {
          self.markShippedLoading = false;
          if (resp.data && resp.data.success) {
            self.showMarkShippedSidebar = false;
            self.markShippedForm.trackingNumber = '';
            self.$swal('Shipped!', 'The shipment has been marked as shipped.', 'success');
            self.LoadItem(self.id);
          } else {
            self.$swal('Error', (resp.data && resp.data.errorMessage) || 'Failed to mark as shipped.', 'error');
          }
        })
        .catch(function(err) {
          self.markShippedLoading = false;
          self.$swal('Error', (err.response && err.response.data && err.response.data.errorMessage) || 'Something went wrong.', 'error');
        });
    },

    CancelOrder: function(item) {
      var self = this;
      this.$http
        .post('/api/common/manualShipments/' + item.id + '/cancel')
        .then(function(resp) {
          self.LoadItem(self.id);
          self.$swal('Success', 'Bulk Shipment was cancelled.', 'success');
        })
        .catch(function(err) {
          self.$swal('Failed', 'Could not cancel.', 'error');
        });
    },

    DownloadPackingListPdfItem: function(manualShipment) {
      var form = document.createElement('form');
      form.setAttribute('method', 'post');
      form.setAttribute('target', '_blank');
      form.setAttribute('action', process.env.VUE_APP_API_URL + '/download/pdf/manualship-packing-list/' + manualShipment.id);
      document.body.appendChild(form);
      form.submit();
    },

    DownloadPackingLabels: function(manualShipment) {
      var form = document.createElement('form');
      form.setAttribute('method', 'post');
      form.setAttribute('target', '_blank');
      form.setAttribute('action', process.env.VUE_APP_API_URL + '/download/pdf/packingunits-labels/' + manualShipment.id);
      document.body.appendChild(form);
      form.submit();
    },

    AutoGenPackagesAndDownloadLabels: function(manualShipment) {
      var form = document.createElement('form');
      form.setAttribute('method', 'post');
      form.setAttribute('target', '_blank');
      form.setAttribute('action', process.env.VUE_APP_API_URL + '/download/pdf/packingunits-labels-autogenerate/' + manualShipment.id);
      document.body.appendChild(form);
      form.submit();
    },

    ImportFileHandler: function() {
      var self = this;
      var reader = new FileReader();
      self.isFileUploading = true;
      var filePicked = this.$refs.fileImportManualShip.files[0];
      reader.onload = function(e) {
        var formData = new FormData();
        formData.append('manualShipmentId', self.itemForm.id);
        formData.append('formFile', filePicked, filePicked.name);
        self.$http
          .post('/attachToManualShip', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then(function(resp) {
            self.isFileUploading = false;
            if (resp.data.url) {
              self.itemForm.attachments = resp.data.attachments;
              self.$swal('File Attached!');
            } else {
              self.$swal('Something went wrong');
            }
          })
          .catch(function(err) {
            console.error(err);
            self.isFileUploading = false;
            self.$swal('Something went wrong');
          });
      };
      reader.readAsDataURL(filePicked);
    },

    ResendEdiDocument: function(ediDocumentId) {
      var self = this;
      this.$swal({
        title: 'Resend EDI Document?',
        text: 'This will resend the EDI document to SPS Commerce.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, resend!'
      }).then(function(result) {
        if (result.value) {
          self.$http
            .post('/api/common/edi-documents/' + ediDocumentId + '/resend')
            .then(function(resp) {
              if (resp.data.success) {
                self.$swal('Success', 'EDI document has been queued for resending.', 'success');
                self.LoadEdiDocuments(self.itemForm.id);
              } else {
                self.$swal({ title: 'Error', text: resp.data.errorMessage || 'Failed to resend EDI document', icon: 'error' });
              }
            })
            .catch(function(err) {
              if (err.response && err.response.data && err.response.data.errorMessage) {
                self.$swal({ title: 'Error', text: err.response.data.errorMessage, icon: 'error' });
              } else {
                self.$swal({ title: 'Error', text: 'Failed to resend EDI document', icon: 'error' });
              }
            });
        }
      });
    }
  }
};
</script>
